import type { OperationsPenKey } from "@/api/endpoints";
import { InfoTooltip } from "@/components/InfoTooltip";
import { PEN_LABEL, PEN_TIP } from "../operationsLabels";

interface Props {
  value: OperationsPenKey | undefined;
  onChange: (next: OperationsPenKey | undefined) => void;
}

const KEYS: OperationsPenKey[] = ["internal", "external"];

/** All / Internal / External: the second lens (2026-10-28), who holds the pen on the open work; combines with the Attention lens. */
export function PenControl({ value, onChange }: Props) {
  return (
    <div className="ops-ctl ops-ctl-lens">
      <label>
        Who holds the pen
        <InfoTooltip inline text={PEN_TIP} />
      </label>
      <div className="unit-toggle ops-lens ops-lens-pen" role="tablist" aria-label="Who holds the pen">
        <button type="button" role="tab" aria-selected={!value} className={!value ? "on" : ""} onClick={() => onChange(undefined)}>
          All
        </button>
        {KEYS.map((key) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={value === key}
            className={`lens-${key}${value === key ? " on" : ""}`}
            onClick={() => onChange(value === key ? undefined : key)}
          >
            <i className="dot" aria-hidden="true" />
            {PEN_LABEL[key]}
          </button>
        ))}
      </div>
    </div>
  );
}
